const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";
const WS_BASE_URL = API_BASE_URL.replace(/^http/, "ws");

export interface VoiceMessage {
    type: string;
    text?: string;
}

type MessageHandler = (message: VoiceMessage) => void;
type AudioHandler = (audio: ArrayBuffer) => void;

class VoiceService {

    private socket: WebSocket | null = null;

    connect(onMessage: MessageHandler, onAudio: AudioHandler, path: string = "/ws") {

        this.socket = new WebSocket(`${WS_BASE_URL}${path}`);

        this.socket.binaryType = "arraybuffer";

        this.socket.onmessage = (event) => {

            if (event.data instanceof ArrayBuffer) {
                onAudio(event.data);
                return;
            }

            const data: VoiceMessage = JSON.parse(event.data);
            onMessage(data);
        };
    }

    sendAudio(buffer: ArrayBuffer) {
        if (this.socket?.readyState === WebSocket.OPEN) {
            this.socket.send(buffer);
        }
    }

    disconnect() {
        this.socket?.close();
        this.socket = null;
    }
}

export default new VoiceService();
